import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { WhatIfsHeader } from './components/WhatIfsHeader/WhatIfsHeader';
import { StyledWrapper } from './WhatIfs.styles';

interface LoadingWhatIfsProps {
  onClose: () => void;
}

export const LoadingWhatIfs = ({ onClose }: LoadingWhatIfsProps) => (
  <StyledWrapper>
    <WhatIfsHeader onClose={onClose} />
    <Box flexGrow={1} display="flex" alignItems="center" justifyContent="center">
      <Loading text="Loading..." />
    </Box>
  </StyledWrapper>
);
